// ======================================================================
// File Name       : ContentHistoryAggregateByProblemContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getEachQuestionAnswerContentSummary, getHistoryListByItemSecernId } from '../../../actions/UserHistoryContentAction';
import Header from '../../../components/Header';
import ContentHistoryAggregateByProblem from '../../../components/userHistory/content/ContentHistoryAggregateByProblem';
import { RETURN_MAX_NUM, SELECT_TARGET_DATA } from '../../../constants/index';
import CustomLink from '../../../components/button/CustomLink';

class ContentHistoryAggregateByProblemContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemSecernId: 0,
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM,
    };

    this.onSearchData = this.onSearchData.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  componentDidMount() {
    const { userHistoryContent, match, history } = this.props;
    const { itemList } = userHistoryContent;
    if (match.params.id && itemList && itemList.length) {
      this.setState({ itemSecernId: match.params.id }, () => {
        this.onSearchData();
      });
    } else {
      history.goBack();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { userHistoryContent, match } = nextProps;
    const { itemList } = userHistoryContent;
    const itemDetail = $.grep(itemList, (e) => e.itemSecernId === match.params.id);
    if (itemDetail.length > 0) {
      this.setState({
        itemDetail: itemDetail[0],
      });
    }
  }

  onSearchData() {
    this.setState(
      {
        startPosition: 0,
      },
      () => {
        this.getEachQuestionAnswerContentSummary();
      }
    );
  }

  getHistoryListByItemSecernId(itemSecernId) {
    const { startPosition, returnMaxNum } = this.state;
    const { userHistoryContent, dispatch } = this.props;
    const { learningEndTimeFrom, learningEndTimeTo } = userHistoryContent;
    const searchInfo = {
      itemList: [itemSecernId],
      startPosition,
      returnMaxNum,
      learningEndTimeFrom,
      learningEndTimeTo,
    };
    dispatch(getHistoryListByItemSecernId(searchInfo, SELECT_TARGET_DATA.DATA));
  }

  getEachQuestionAnswerContentSummary() {
    const { userHistoryContent, dispatch } = this.props;
    const { learningEndTimeFrom, learningEndTimeTo } = userHistoryContent;
    const { itemSecernId } = this.state;
    const params = {
      itemSecernId,
      learningEndTimeFrom,
      learningEndTimeTo,
    };
    dispatch(getEachQuestionAnswerContentSummary(params));
  }

  goBack() {
    const { history } = this.props;
    history.goBack();
  }

  render() {
    const { itemDetail } = this.state;
    const { userHistoryContent } = this.props;
    let { learningEndTimeFrom, learningEndTimeTo } = userHistoryContent;
    const { questionAnswerSummaryList } = userHistoryContent;
    if (learningEndTimeFrom || learningEndTimeTo) {
      learningEndTimeFrom = learningEndTimeFrom ? learningEndTimeFrom.substring(0, 10).replace(/-/g, '/') : '';
      learningEndTimeTo = learningEndTimeTo ? learningEndTimeTo.substring(0, 10).replace(/-/g, '/') : '';
    }
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          text="コンテンツ別履歴一覧に戻る"
          icon="bi bi-chevron-left"
          onClick={this.goBack}
        />
        <Header name="コンテンツ別履歴情報　問題別集計" />
        <ContentHistoryAggregateByProblem
          goBack={this.goBack}
          itemDetail={itemDetail}
          questionAnswerSummaryList={questionAnswerSummaryList}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { userHistoryContent } = state;
  const { questionAnswerSummaryList } = userHistoryContent;
  return {
    userHistoryContent,
    questionAnswerSummaryList,
  };
};

export default connect(mapStateToProps)(ContentHistoryAggregateByProblemContainer);
